import React, { useRef } from "react";
import { FaRegFileImage } from "react-icons/fa6";
import { MdEmojiEmotions } from "react-icons/md";
import { GrSend } from "react-icons/gr";
import EmojiPicker from "emoji-picker-react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { quillModules } from "../../../../../components/shared/quillConfig";
import { handleErrorImg } from "../../../../../service/utils/utils";
import AVATAR_DEFAULT from "../../../../../images/avatar-default.jpg";
import QuoteBox from "./QuoteBox";

function CommentForm({
    postData,
    commentContent,
    onCommentChange,
    imageBase64s,
    onImageUpload,
    onImageDelete,
    onSubmit,
    showEmoji,
    onToggleEmoji,
    onEmojiClick,
    replyingQuote,
    onCloseQuote,
    commentTextareaRef,
    inputSectionRef,
    handleImageClick
}) {
    return (
        <div ref={inputSectionRef} className="mt-4 flex items-center w-full border border-white rounded-lg p-2">
            {/* Avatar */}
            <div className="w-[20%] pr-2 flex justify-center">
                <img
                    src={postData?.Avatar || AVATAR_DEFAULT}
                    alt="avatar"
                    className="w-[96px] h-[96px] aspect-square mr-3 object-cover"
                    onError={(e) => handleErrorImg(e.target)}
                />
            </div>

            {/* Form */}
            <div className="w-[80%]">
                {/* Quote Box */}
                <QuoteBox quoteText={replyingQuote} onClose={onCloseQuote} />

                {/* Editor with Action Buttons */}
                <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                    {/* Left Buttons */}
                    <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 8 }}>
                        {/* Emoji Button */}
                        <button
                            type="button"
                            onClick={onToggleEmoji}
                            style={{ background: "transparent", border: "none", cursor: "pointer" }}
                        >
                            <MdEmojiEmotions size={28} />
                        </button>
                        {/* Image Button */}
                        <button
                            type="button"
                            onClick={handleImageClick}
                            style={{ background: "transparent", border: "none", cursor: "pointer" }}
                        >
                            <FaRegFileImage size={28} />
                        </button>
                    </div>

                    {/* ReactQuill Editor */}
                    <div style={{ position: "relative", flex: 1 }}>
                        <ReactQuill
                            className="main-comment-quill"
                            theme="snow"
                            value={commentContent || ""}
                            onChange={onCommentChange}
                            style={{
                                background: "#fff",
                                color: "#000",
                                minHeight: "100px",
                                marginBottom: "8px",
                                maxWidth: "100%",
                                overflowWrap: "break-word",
                                wordBreak: "break-all",
                                wordWrap: "break-word",
                            }}
                            ref={commentTextareaRef}
                            modules={quillModules}
                        />

                        {/* Floating Emoji Button (inside editor) */}
                        <button
                            type="button"
                            onClick={onToggleEmoji}
                            style={{ position: "absolute", top: 8, right: 8, zIndex: 10 }}
                        >
                            <MdEmojiEmotions size={28} />
                        </button>

                        {/* Emoji Picker */}
                        {showEmoji && (
                            <div style={{ position: "absolute", top: 40, right: 8, zIndex: 20 }}>
                                <EmojiPicker onEmojiClick={onEmojiClick} />
                            </div>
                        )}
                    </div>
                </div>

                {/* Image Preview */}
                {Array.isArray(imageBase64s) && imageBase64s.length > 0 && (
                    <div className="flex gap-4 mb-4 mt-2">
                        {imageBase64s.map((item, index) => (
                            <div className="relative w-20 h-20 rounded-lg overflow-hidden" key={index}>
                                <div
                                    onClick={() => onImageDelete(index)}
                                    className="absolute top-1 right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-white cursor-pointer hover:bg-red-700"
                                >
                                    X
                                </div>
                                <img className="w-full h-full object-cover" src={item} alt="preview" />
                            </div>
                        ))}
                    </div>
                )}

                {/* Action Buttons */}
                <div className="flex gap-2">
                    <button
                        className="flex items-center gap-1 px-4 py-2 bg-gray-700 text-white rounded-lg hover:bg-gray-600"
                        onClick={() => document.querySelector("#commentImageInput").click()}
                        type="button"
                    >
                        <FaRegFileImage />
                        <span>Tải ảnh lên</span>
                    </button>
                    <input
                        id="commentImageInput"
                        type="file"
                        className="hidden"
                        onChange={onImageUpload}
                        accept="image/*"
                    />
                    <button
                        className="flex items-center gap-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-500"
                        onClick={onSubmit}
                        type="button"
                    >
                        <GrSend />
                        <span>Trả lời</span>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CommentForm;

